// authConfig.js
export const msalConfig = {
  auth: {
    clientId: '1a96cc99-88e9-4d70-84e0-f994f85ca244',
    authority: 'https://login.microsoftonline.com/cdc3d9e9-088c-491e-ab38-f2ff938b2f73',
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
    navigateToLoginRequestUrl: false,
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false,
  },
};

export const loginRequest = {
  scopes: ['api://1a96cc99-88e9-4d70-84e0-f994f85ca244/user_impersonation'],
};

export const functionApiScopes = ['api://1a96cc99-88e9-4d70-84e0-f994f85ca244/user_impersonation'];
